export const ORDERED_LIST = 'ordered_list';
export const UNORDERED_LIST = 'unordered_list';
export const LIST_ITEM = 'list_item';
